module.exports = __webpack_public_path__ + "img/img_48@2x.439d82e8.png";